import { CheckOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import React, { Fragment, useEffect, useState } from 'react';
import { DetailItem } from '../../../types/home';
import styles from './ShoppingCart.module.scss';

export default function CartDetails(props: { data: DetailItem[] }) {
  const [sum, setSum] = useState<number>(0);

  useEffect(() => {
    const total = props.data.reduce((a, b) => {
      return a + b.money;
    }, sum);

    setSum(total);
  }, [props.data, sum]);

  const content = props.data.map((d, index) => {
    return (
      <Row style={{ marginTop: '5px' }} key={index}>
        <Col span={2}>
          <CheckOutlined />
        </Col>
        <Col span={10} className={styles.sumLabel}>
          {d.label}
        </Col>
        <Col span={12} className={styles.sumPay}>
          <span className={styles.payUnit}>€</span>
          {d.money.toFixed(2)}
        </Col>
      </Row>
    );
  });

  return (
    <Fragment>
      {content}
      <Row style={{ marginTop: '15px' }}>
        <Col span={10} offset={2} className={styles.sumLabel}>
          <b>Total:</b>
        </Col>
        <Col span={12} className={styles.sumPay}>
          <b>
            <span className={styles.payUnit}>€</span>
            {sum.toFixed(2)}
          </b>
        </Col>
      </Row>
    </Fragment>
  );
}
